import { useStrict } from 'mobx';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Router } from './routes';
import { initTelemetry } from './telemetry';

function main() {
  initTelemetry();  // Includes reporting unhandled exceptions. Do this first.

  if (!isBrowserSupported()) {
    const message = 'Your browser is not supported. Please use a modern browser such as ' +
      '<a href="https://www.google.com/chrome/">Google Chrome</a>.';
    mount().innerHTML = message;
    return;
  }

  useStrict(true);

  render(Router);

  if (process.env.NODE_ENV !== 'production') {
    beginHotReload();
  }
}

function isBrowserSupported() {
  const style = document.documentElement.style;
  return ('flexWrap' in style) || ('WebkitFlexWrap' in style) || ('msFlexWrap' in style);
}

function mount(): HTMLElement {
  return document.getElementById('mount')!;  // tslint:disable-line:no-non-null-assertion
}

function render(UpdatedRouter: React.ComponentType) {
  ReactDOM.render(
    <BrowserRouter>
      <UpdatedRouter/>
    </BrowserRouter>,
    mount(),
  );
}

declare const module: { readonly hot: { readonly accept: any } };

function beginHotReload() {
  if (module.hot) {
    module.hot.accept('./routes', () => {
      const HotRouter = require('./routes').Router;  // tslint:disable-line:no-require-imports
      render(HotRouter);
    });
  }
}

main();



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/index.tsx